import { Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { ReactComponent as Success } from "../assets/success_logo.svg";

const SuccessfullFeedback = () => {
  const [counter, setCounter] = useState(5);

  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);
    } else {
      window.location.href = "https://eximpe.com";
    }
  }, [counter]);

  return (
    <Flex
      direction="column"
      w="full"
      justify="center"
      alignItems="center"
      py={8}
    >
      <Text fontWeight="semibold" fontSize="2xl" pb={12}>
        Request A Demo
      </Text>
      <Success />
      <Text fontSize="sm" pt={4} fontWeight="medium" color="green.400">
        Form Submitted Successfully
      </Text>
      <Text fontSize="xs" fontWeight="normal" color="gray.400">
        We willl get in touch with you shortly
      </Text>
      <Text fontSize="md" pt={4} fontWeight="bold" color="green.400">
        Redirecting to website in {counter}
      </Text>
    </Flex>
  );
};

export default SuccessfullFeedback;
